import { Trans } from '@lingui/macro';
import { Language, Straighten, ViewSidebar, Visibility } from '@mui/icons-material';
import { Skeleton } from '@mui/material';
import { Box } from '@mui/system';
import { Suspense } from 'react';
import MetricsTab from '../components/MetricsTab';
import RegionTab from '../components/RegionTab';
import InterfaceTab from '../components/InterfaceTab';
import { VisibleUnitsTab } from '../components/VisibleUnitsTab';

export const useTabs = (userId: number | null) => {
  const tabs = [
    {
      id: 'language',
      label: (
        <Box display="flex" alignItems="center" gap={2}>
          <Language fontSize="small" />
          <Trans>Idioma y región</Trans>
        </Box>
      ),
      component: (
        <Suspense fallback={<Skeleton variant="rounded" height={400} />}>
          <RegionTab userId={userId} />
        </Suspense>
      ),
    },
    {
      id: 'units',
      label: (
        <Box display="flex" alignItems="center" gap={2}>
          <Straighten fontSize="small" />
          <Trans>Unidades preferidas</Trans>
        </Box>
      ),
      component: (
        <Suspense fallback={<Skeleton variant="rounded" height={400} />}>
          <MetricsTab userId={userId} />
        </Suspense>
      ),
    },
    {
      id: 'visible-units',
      label: (
        <Box display="flex" alignItems="center" gap={2}>
          <Visibility fontSize="small" />
          <Trans>Unidades visibles</Trans>
        </Box>
      ),
      component: (
        <Suspense fallback={<Skeleton variant="rounded" height={400} />}>
          <VisibleUnitsTab userId={userId} />
        </Suspense>
      ),
    },
    {
      id: 'interface',
      label: (
        <Box display="flex" alignItems="center" gap={2}>
          <ViewSidebar fontSize="small" />
          <Trans>Interfaz</Trans>
        </Box>
      ),
      component: (
        <Suspense fallback={<Skeleton variant="rounded" height={400} />}>
          <InterfaceTab userId={userId} />
        </Suspense>
      ),
    },
  ];

  return tabs;
};
